import { css } from '@emotion/react';
import { useTheme } from '@mui/material';

const useStyles = () => {
  const theme = useTheme();
  const { primary, background, divider, text } = theme.palette;
  const { fontFamily } = theme.typography;
  const { shadows } = theme;
  const { md, sm, xl } = theme.breakpoints;

  // const navWrapper = css`
  //   width: 100%;
  //   padding: 0 50px;
  //   margin: 0 auto;
  //   position: sticky;
  //   top: 0;
  //   z-index: 111;
  //   background: ${background.default};
  //   border-bottom: 1px solid ${divider};

  //   @media (max-width: 1150px) {
  //     padding: 0 25px;
  //   }

  //   @media (max-width: ${`${md}px`}) {
  //     background: ${background.gray3};
  //   }
  // `;

  // const desktopNavWrapper = css`
  //   display: block;

  //   @media (max-width: ${`1150px`}) {
  //     display: none;
  //   }
  // `;

  // const mobileNavWrapper = css`
  //   display: none;

  //   @media (max-width: ${`1150px`}) {
  //     display: block;
  //   }
  // `;

  // const nav = css`
  //   width: 100%;
  //   max-width: 1340px;
  //   height: 60px;
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: center;
  //   margin: 0 auto;
  // `;

  // const logoStyle = css`
  //   display: flex;
  //   align-items: center;
  // `;

  const hideShopButtonOnMobile = css`
    display: none !important;

    @media (min-width: ${`${sm}px`}) {
      display: inline-flex !important;
    }
  `;

  const linkDrawer = css`
    width: 100%;
    max-width: 1440px;
    height: 200px;
    background: ${background.default};
    box-shadow: ${shadows[1]};
    display: none;
    align-items: flex-start;
    padding: 25px 50px;
    margin: 0 auto;
  `;

  const linkDrawerWrapper = css`
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    display: flex;
    align-items: flex-start;
    padding: 0 50px;
  `;

  const imageLink = css`
    position: absolute;
    bottom: 0px;
    color: white;
    width: 100%;
    text-align: center;
    font-weight: 200;
    font-size: 14px;
    line-height: 14px;
    text-decoration: underline;
    text-decoration-color: white;
  `;

  const smallDrawer = css`
    height: 91px;
    background: transparent;
    box-shadow: none;
    padding: 0;
    min-width: 100vw;
  `;

  const visibleDrawer = css`
    display: flex;
    position: absolute;
    top: 0px;
    left: 50%;
    transform: translateX(-50%);
    animation: fade-in 0.25s ease;

    @keyframes fade-in {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  `;

  const drawerImgWrapper = css`
    width: 366px;
    height: 149px;
    border: 1px solid ${divider};
    margin: 0 53px 0 0;
    position: relative;
    background: ${background.gray3};
  `;

  const drawerLinks = css`
    max-width: calc(100% - 366px);
    min-width: 368px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
  `;

  const smallLinks = css`
    width: 468px;
    min-height: 91px;
    position: fixed;
    display: flex;
    align-items: center;
    background: ${background.default};
    box-shadow: ${shadows[1]};
    padding: 25px 50px;
  `;

  const linkWrapper = css`
    width: 100%;
    max-width: 250px;

    & a,
    button {
      font-weight: 300;
      font-size: 16px;
      line-height: 21px;
      display: flex;
      width: auto;
      text-decoration: none;
      color: ${primary.main};
      transition: all 0.25s ease;
      padding: 7.5px 0;
    }

    &:hover a,
    :hover button {
      margin-left: -10px;
      color: ${primary.main};
      font-weight: 500;
      font-size: 16px;
      line-height: 21px;
      text-decoration: none;
    }

    & button:disabled {
      color: #e4ded6;
      border-color: #e4ded6;
    }
  `;

  const smallLinkWrapper = css`
    width: auto;
    max-width: unset;

    &:hover a {
      margin: 0;
      font-weight: 300;
    }
  `;

  const linkList = css`
    height: 100%;
    display: flex;
    align-items: center;
    font-family: ${fontFamily};
    list-style-type: none;
    font-weight: 300;
    margin: 0;

    & li {
      margin-left: 35px;
    }

    & li:last-child {
      margin-left: 28px;
    }

    & .nav-link button,
    & .nav-link > a {
      height: 60px;
      display: flex;
      align-items: center;
      transition: border 0.25s ease;
      cursor: pointer;
      font-weight: 300;
      padding: 0;

      & a {
        height: 58px;
        display: flex;
        align-items: center;
        text-decoration: none;
      }

      &.active {
        border-bottom: 2px solid ${primary.main};
      }

      &:hover {
        border-bottom: 2px solid ${primary.main};
      }
    }
  `;

  const navMobile = css`
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid ${divider};
    width: 100%;
  `;

  const logoWrapper = css`
    display: flex;
    align-items: center;
  `;

  const mobileLinkWrapper = css`
    border-top: 1px solid ${divider};
    margin-left: 25px;
    margin-right: 25px;
  `;

  const mobileLink = css`
    width: 100%;
    font-weight: 400;
    font-size: 24px !important;
    line-height: 30px;
    min-height: 54px !important;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0;
    background: white;
  `;

  const navMobileLinks = css`
    list-style-type: none;
    padding: 0;
    margin: 0;

    & li {
      margin: 0 0 15px;
    }

    & li a {
      color: ${text.secondary};
      font-weight: 300;
      font-size: 16px;
      line-height: 21px;
      transition: font-weight 0.25s ease;
    }

    & li a:hover {
      font-weight: 700;
    }
  `;

  const menuItemStyle = css`
    display: flex;
    flex-direction: column;
  `;

  const blurpleLink = css`
    color: ${primary.dark};
  `;

  const offlineStyle = css`
    color: ${divider};
  `;

  const chatOfflineMessage = css`
    font-weight: 200;
    font-size: 14px;
    line-height: 18px;
    margin-left: 14px;
    text-align: left;
  `;

  const cartWrapper = css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 8px;
    line-height: 8px;
    padding: 0 0 3px 2px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 38px;
    min-width: 38px;
    height: 58px;
    margin: 0 33px 0 16px;

    @media (max-width: ${`${md}px`}) {
      background-color: transparent;
    }
  `;

  const noLinks = css`
    display: flex;
    align-items: center;
    color: #2c3138;
    font-size: 14px;
    font-weight: 300;

    div {
      margin-right: 25px;
    }
  `;

  const seperator = css`
    height: 36px;
    width: 1px;
    background-color: #002334;
  `;

  return {
    // nav,
    // navWrapper,
    // desktopNavWrapper,
    // mobileNavWrapper,
    // navMobile,
    mobileLinkWrapper,
    mobileLink,
    // menuItemStyle,
    navMobileLinks,
    visibleDrawer,
    linkDrawer,
    linkDrawerWrapper,
    smallDrawer,
    drawerImgWrapper,
    drawerLinks,
    smallLinks,
    linkWrapper,
    smallLinkWrapper,
    hideShopButtonOnMobile,
    // linkList,
    // logoStyle,
    // logoWrapper,
    blurpleLink,
    offlineStyle,
    chatOfflineMessage,
    cartWrapper,
    imageLink,
    // noLinks,
    // seperator,
  };
};

export default useStyles;
